export default "__VITE_ASSET__Dr3hMaj5__"